<template>
  <div
    class="" v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-card flat class="doclist-sidebar mt-4">
            <v-card-text class="pa-5">
              <div class="doclist-sidebar__title">
                <v-icon size="16" :color="set_color" class="mr-2">mdi-folder-outline</v-icon>
                <span :style="`color: ${set_color}`">Jenis Dokumen</span>
              </div>

              <template v-if="process.load">
                <div v-for="n in 6" :key="n" class="doclist-sidebar__skeleton">
                  <v-skeleton-loader type="text" width="70%"></v-skeleton-loader>
                </div>
              </template>

              <div v-else-if="category.length > 0">
                <router-link
                  v-for="(item, index) in category"
                  :key="index"
                  :to="`/page?jenis=${item.slug}`"
                  class="doclist-sidebar__item"
                  @mouseover.native="voiceHover(item.name)">
                  <span class="doclist-sidebar__name">{{ item.name }}</span>
                  <span class="doclist-sidebar__count" :style="`background: ${set_color}`">{{ item.count }}</span>
                </router-link>
              </div>
            </v-card-text>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { createSEOMeta } from '@/utils/seo'
  export default {
    middleware: false,
    props: {

    },
    data () {
      return {
        category: [],
        process: {
          load: false,
          category: false
        },
        message: {
          success: '',
          error: ''
        },
      }
    },
    head () {


    },
    components: {

    },
    watch: {

    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.member.auth.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        console.log(this.$store.state.header.config.color)
        return this.$store.state.header.config.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchCategory()
    },
    methods: {
      voiceHover (item) {
        responsiveVoice.cancel(); // Cancel anything else that may currently be speaking
        responsiveVoice.speak(item, 'Indonesian Female');
      },
      async fetchCategory () {
        this.process.load = true

        let params = {
          limit: 1000000,
          'title[nin]': 'Surat Keputusan,Surat Keputusan DPRD'
        }

        await this.$axios.$get(`${process.env.API}sites/doc/doc_type`, { params })
        .then(response => {
          let res = response
          this.process.load = false

          if (res.status === 200) {

            let selecCategory = []
            selecCategory = res.results.data.map(item => {
              const container = {};
              container.par_id = item.par_id;
              container.name = item.title;
              container.count = item.count;
              container.slug = (item.title.split(' ').join('-')).toLowerCase();
              return container
            })

            for (let i in selecCategory) {
              if(selecCategory[i].par_id !== '0') {
                this.category.push(
                  {
                    name: selecCategory[i].name,
                    slug: selecCategory[i].slug,
                    count: selecCategory[i].count
                  }
                )
              }

            }
          }
        })
      },
    }
  }
</script>

<style scoped>
.doclist-sidebar {
  border: 1px solid #E7E9EC !important;
  border-radius: 10px !important;
}
.doclist-sidebar__title {
  display: flex;
  align-items: center;
  font-size: 13.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
  margin-bottom: 10px;
}
.doclist-sidebar__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 4px;
  border-bottom: 1px solid #F0F1F3;
  text-decoration: none;
  color: #22262B;
  transition: color 0.15s ease;
}
.doclist-sidebar__item:last-child {
  border-bottom: none;
}
.doclist-sidebar__item:hover {
  color: #E0355B;
}
.doclist-sidebar__name {
  font-size: 13.5px;
  font-weight: 500;
  line-height: 1.4;
}
.doclist-sidebar__count {
  flex: none;
  min-width: 26px;
  height: 22px;
  padding: 0 7px;
  border-radius: 11px;
  color: #fff;
  font-size: 11.5px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
.doclist-sidebar__skeleton {
  padding: 10px 4px;
}
</style>